export default (axios) => ({
    getAll: (params) => axios.get('u/categories?type=blog&origin=benhvien16a.com', { params }).then((_) => _.data),
});
